import * as React from 'react';
import { useParams } from 'react-router-dom';
import Page from '../../../components/Page';
import UserContainer from '../containers/UserContainer';
import UserInfoContainer from '../containers/UserInfoContainer';
import UserOrganizationPanel from '../containers/UserOrganizationPanel';

const UserDetail: React.FC = () => {
  const { id } = useParams();

  return (
    <Page header="userDetail">
      <UserInfoContainer userId={id!} showAddSubscription />
      <UserOrganizationPanel userId={id!} />
      <UserContainer userId={id!} />
    </Page>
  );
};

export default UserDetail;
